import { defineMessages } from '@redbubble/next/intl';

export const messages = defineMessages({
  member: {
    defaultMessage: 'Become a member.',
  },
  discount: {
    defaultMessage: 'Get 25% off your first order.',
  },
  content: {
    defaultMessage:
      'Plus other neat perks and exclusive savings to help you find the very thing.',
  },
  signUp: {
    defaultMessage: 'Sign up',
  },
});
